'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/apisauce/~/axios/lib/cancel/isCancel.js
// module id = 402
// module chunks = 0